import { useCallback, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import lang from '../../lib/language';
import { DividendPayerData } from '../../lib/models/fundamental/types';
import { RootState } from '../../lib/store';

import { useIsMobile } from '../../hooks';

import Chart from './Chart/Chart';
import CompanyInfo from './CompanyInfo/CompanyInfo';
import CompanyInfoMobile from './CompanyInfo/CompanyInfoMobile';

import styles from './DividendPyersAndHighGrowthCompanies.module.scss';

type OwnProps = {
  dividendPayerContent: DividendPayerData[]
}
type Props = OwnProps & ReduxProps;

const DividendPayers = ({ dividendPayerContent, companyLogoAndName }: Props) => {
  const MOBILE_DIVIDENDS_COUNT_LIMIT = 6;
  const { isMobile } = useIsMobile();
  const [dividend, setDividend] = useState(dividendPayerContent[0]);

  useEffect(() => {
    setDividend(dividendPayerContent[0]);
  }, [dividendPayerContent]);

  const onChange = useCallback((key) => {
    const filteredDividends = dividendPayerContent.find(el => el.symbol === key);
    if (filteredDividends) setDividend(filteredDividends);
  }, [dividendPayerContent]);

  return (
    <>
      { isMobile ? (
        <div className={styles.wrapper}>
          <div className={styles.chartDetails}>
            <p className={styles.dotWrapper}>
              <span className={styles.activeDot} />
              {lang.commonDiscoverDividendPayersLegend()}
            </p>
            <Chart
              data={isMobile ? dividendPayerContent.slice(0, MOBILE_DIVIDENDS_COUNT_LIMIT) : dividendPayerContent}
              yAxis={'dividendYield'}
              currentItemId={dividend ? dividend.symbol : ''}
              isHighGrowthCompany={false}
              onItemChange={onChange}
            />
          </div>
          <div className={styles.line} />
          { dividend ? (
            <CompanyInfoMobile
              areDividends
              symbol={dividend.symbol}
              logo={companyLogoAndName[dividend.symbol].logo}
              url={companyLogoAndName[dividend.symbol].url ?? dividend.url}
              companyName={companyLogoAndName[dividend.symbol].name}
              volume={dividend.volume}
              marketCap={dividend.marketCap}
              prevCloseAndEPS={dividend.close}
              dividendRateAndRevenue={dividend.dividendRate}
            />
          ) : (
            <CompanyInfoMobile
              isLoading
            />
          )}
        </div>
      ) : (
        <div className={styles.wrapper}>
          { dividend ? (
            <CompanyInfo
              areDividends
              symbol={dividend.symbol}
              logo={companyLogoAndName[dividend.symbol].logo}
              url={companyLogoAndName[dividend.symbol].url ?? dividend.url}
              companyName={companyLogoAndName[dividend.symbol].name}
              volume={dividend.volume}
              marketCap={dividend.marketCap}
              prevCloseAndEPS={dividend.close}
              dividendRateAndRevenue={dividend.dividendRate}
            />
          ) : (
            <CompanyInfo
              isLoading
            />
          )}
          <div className={styles.chartDetails}>
            <p className={styles.dotWrapper}>
              <span className={styles.activeDot} />
              {lang.commonDiscoverDividendPayersLegend()}
            </p>
            <Chart
              data={dividendPayerContent}
              yAxis={'dividendYield'}
              currentItemId={dividend ? dividend.symbol : ''}
              isHighGrowthCompany={false}
              onItemChange={onChange}
            />
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  companyLogoAndName: state.fundamental.companyLogoAndName,
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(DividendPayers);
